(function () {
    // ---- Slide data (edit this array to add/remove/change slides) ----
    const slideData = [
      {
        image: 'https://cdn.shopify.com/s/files/1/0703/8264/9585/files/0_to_6_months.png?v=1787049471',
        alt: 'Parent and baby playing with a sensory toy',
        title: '0-6 months',
        text: 'From birth to six months, your baby experiences rapid growth in physical, cognitive, and social skills. They improve head control, begin rolling over, and sit with support while expressing early emotions and bonding with you.',
        url: 'https://www.ejtoyco.com/products/0-6-months-toy-box'
      },
      {
        image: 'https://cdn.shopify.com/s/files/1/0703/8264/9585/files/7_to_12_months.png?v=1787049470',
        alt: 'Baby exploring toys',
        title: '7-12 months',
        text: 'Between seven and twelve months, your baby\'s cognitive and fine motor skills flourish as they explore their surroundings and begin to understand cause and effect.',
        url: 'https://www.ejtoyco.com/products/7-12-months'
      },
      {
        image: 'https://cdn.shopify.com/s/files/1/0703/8264/9585/files/13_to_18_months.png?v=1787049469',
        alt: 'Toddler playing',
        title: '13-18 months',
        text: 'Between 13 and 18 months, children experience rapid cognitive and motor development, expanding their vocabulary, following simple instructions, and refining hand-eye coordination.',
        url: 'https://www.ejtoyco.com/products/13-18-months'
      },
      {
        image: 'https://cdn.shopify.com/s/files/1/0703/8264/9585/files/19_to_24_months.png?v=1787049470',
        alt: 'Child playing with blocks',
        title: '19-24 months',
        text: 'From nineteen to twenty-four months, your little one experiences exciting cognitive and fine motor development, improving problem-solving skills and gaining greater control over their movements.',
        url: 'https://www.ejtoyco.com/products/19-24-months'
      },
      {
        image: 'https://cdn.shopify.com/s/files/1/0703/8264/9585/files/25_to_36_months.png?v=1787049470',
        alt: 'Child playing with blocks',
        title: '25-36 months',
        text: 'From nineteen to twenty-four months, your little one experiences exciting cognitive and fine motor development, improving problem-solving skills and gaining greater control over their movements.',
        url: 'https://www.ejtoyco.com/products/25-36-months'
      }
    ];
 
    const track = document.getElementById('sliderTrack');
    const dotsContainer = document.getElementById('sliderDots');
    const viewport = document.querySelector('.stage-slider');
 
    const realCount = slideData.length;
    const AUTOPLAY_DELAY = 2000; // ms between auto-advances
 
    // Build extended slide list: [clone(last), ...real slides, clone(first)]
    // This is what makes the wheel effect possible: slide 1's left neighbour
    // is genuinely the last slide's clone, and the last slide's right
    // neighbour is genuinely the first slide's clone.
    function buildSlideEl(data, realIndex) {
      const el = document.createElement('div');
      el.className = 'stage-slide';
      el.dataset.realIndex = realIndex;
      el.innerHTML =
        '<a class="stage-slide__link" href="' + data.url + '" aria-label="' + data.title + '">' +
          '<img class="stage-slide__image" src="' + data.image + '" alt="' + data.alt + '" />' +
          '<div class="stage-slide__overlay">' +
            '<h3 class="stage-slide__title">' + data.title + '</h3>' +
            '<p class="stage-slide__text">' + data.text + '</p>' +
          '</div>' +
        '</a>';
      return el;
    }
 
    const extended = [];
    extended.push(buildSlideEl(slideData[realCount - 1], realCount - 1)); // clone of last
    slideData.forEach((data, i) => extended.push(buildSlideEl(data, i)));  // real slides
    extended.push(buildSlideEl(slideData[0], 0));                          // clone of first
 
    extended.forEach((el) => track.appendChild(el));
 
    // Build dots (one per REAL slide, not per clone)
    slideData.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'stage-slider__dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', () => {
        goToReal(i);
        restartAutoplay();
      });
      dotsContainer.appendChild(dot);
    });
    const dots = Array.from(dotsContainer.querySelectorAll('.stage-slider__dot'));
 
    // pointer indexes into `extended` (0..realCount+1). Start on the first real slide.
    let pointer = 1;
    let autoplayTimer = null;
 
    function realIndexForPointer(p) {
      return ((p - 1) % realCount + realCount) % realCount;
    }
 
    function render(withTransition) {
      track.classList.toggle('no-transition', !withTransition);
 
      const currentReal = realIndexForPointer(pointer);
 
      extended.forEach((el) => {
        el.classList.toggle('is-active', Number(el.dataset.realIndex) === currentReal);
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === currentReal);
      });
 
      const activeEl = extended[pointer];
      const slideCenter = activeEl.offsetLeft + activeEl.offsetWidth / 2;
      const viewportCenter = viewport.offsetWidth / 2;
      const offset = slideCenter - viewportCenter;
 
      track.style.transform = 'translateX(' + (-offset) + 'px)';
    }
 
    // Advance forward like a wheel: always increments pointer, and once it
    // scrolls past the trailing clone, silently resets to the matching real
    // slide with no transition so the motion never visibly reverses.
    function advance() {
      pointer += 1;
      render(true);
 
      if (pointer === extended.length - 1) {
        // We've landed on the clone of the first slide — after the
        // animation finishes, snap (invisibly) back to the real first slide.
        const onTransitionEnd = () => {
          track.removeEventListener('transitionend', onTransitionEnd);
          pointer = 1;
          render(false);
          // Force reflow so the next transition re-enables cleanly
          void track.offsetWidth;
        };
        track.addEventListener('transitionend', onTransitionEnd);
      }
    }
 
    // Direct jump to a specific real slide (used by dots) — takes the
    // shortest path through the extended array so it never has to loop
    // all the way around.
    function goToReal(realIndex) {
      pointer = realIndex + 1;
      render(true);
    }
 
    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = setInterval(advance, AUTOPLAY_DELAY);
    }
 
    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }
 
    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }
 
    // Pause on hover / focus, resume on leave
    viewport.addEventListener('mouseenter', stopAutoplay);
    viewport.addEventListener('mouseleave', startAutoplay);
    viewport.addEventListener('focusin', stopAutoplay);
    viewport.addEventListener('focusout', startAutoplay);
 
    // Pause when tab isn't visible, resume when it is
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });
 
    window.addEventListener('resize', () => render(false));
 
    // Initial center after layout, then start autoplay
    requestAnimationFrame(() => {
      render(false);
      startAutoplay();
    });
  })();